webpackJsonp([148510041631291],{

/***/ 281:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.pageQuery = undefined;
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactHelmet = __webpack_require__(96);
	
	var _reactHelmet2 = _interopRequireDefault(_reactHelmet);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var Redirect = function Redirect(_ref) {
	  var data = _ref.data,
	      pathContext = _ref.pathContext;
	  var newPath = pathContext.newPath;
	
	  var newUrl = '' + data.site.siteMetadata.siteUrl + newPath;
	
	  return _react2.default.createElement(
	    'div',
	    null,
	    _react2.default.createElement(
	      _reactHelmet2.default,
	      null,
	      _react2.default.createElement(
	        'title',
	        null,
	        'Moved to new URL: ' + newUrl
	      ),
	      _react2.default.createElement('meta', { httpEquiv: 'refresh', content: '0;url=' + newPath }),
	      _react2.default.createElement('meta', { name: 'robots', content: 'noindex,follow' })
	    ),
	    _react2.default.createElement(
	      'h1',
	      null,
	      'This post has been moved'
	    ),
	    _react2.default.createElement(
	      'p',
	      null,
	      'This post has been moved to ' + newUrl
	    ),
	    _react2.default.createElement(
	      'p',
	      null,
	      'If your browser doesn\'t redirect you to the new location please',
	      ' ',
	      _react2.default.createElement(
	        'a',
	        { href: newPath },
	        'click here'
	      ),
	      '.'
	    )
	  );
	};
	
	exports.default = Redirect;
	var pageQuery = exports.pageQuery = '** extracted graphql fragment **';

/***/ })

});


// WEBPACK FOOTER //
// component---src-templates-redirect-js-aad810acf6fa3f52e446.js